import {Component, OnInit} from '@angular/core';
import {NgForOf} from "@angular/common";
import {SectionComponent} from "../../elements/section/section.component";
import {Lightbox} from "ngx-lightbox";
import {FullScreenSliderComponent} from "../../elements/full-screen-slider/full-screen-slider.component";
import {ApiService} from "../../../services/api.service";
import {getImageUrl} from "../../../functions/getImageUrl";

@Component({
  selector: 'app-fact',
  imports: [
    NgForOf,
    FullScreenSliderComponent
  ],
  templateUrl: './fact.component.html',
  styleUrl: './fact.component.scss'
})
export class FactComponent  implements OnInit{
  slides: string[] = [
    'app/assets/facts/1.png',
    'app/assets/facts/2.png',
    'app/assets/facts/3.png',
    'app/assets/facts/4.png',
    'app/assets/facts/5.png',
  ];

  constructor(
      private apiService: ApiService
  ) { }



  activeSlide: string = this.slides[0];

  active: boolean = false;
  loading: boolean = false;

  activeIndex: number = 0;

  ngOnInit() {
    this.loading = false;
    this.apiService.getPaginatedData('public/fact', 1, 1000, '').subscribe((data) => {
      this.slides = data.content.sort((a: any, b: any) => a.orderNumber - b.orderNumber).map((v: any) => v.image.toString());
      setTimeout(() => {
        this.loading = false;
      }, 0);
    })
  }

  open(index: number, slide: string): void {
    setTimeout(() => {
      this.activeSlide = slide;
      this.active = !this.active;
    }, 100);
  }

  clickSlider(type: string) {
    let newIdx;
    if (type == 'left') {
      newIdx = this.activeIndex - 1;
      if (newIdx < 0) {
        newIdx = this.slides.length - 1;
      }
    } else {
      newIdx = this.activeIndex + 1;
      if (newIdx > this.slides.length - 1) {
        newIdx = 0;
      }
    }
    this.activeIndex = newIdx;
    this.activeSlide = this.slides[newIdx];
  }

  protected readonly getImageUrl = getImageUrl;
}
